export class FileDetails {
  fileDescription: string;
  fileJsonDetails: any

  constructor(description: string, details: any) {
    this.fileDescription = description;
    this.fileJsonDetails = details;
  }
}
